module.exports = __webpack_public_path__ + "ff0f5a765705c3a55bd28d7b5341093b.jpg";